import styled from 'styled-components';

const Footer = styled.footer`
  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    padding: ${(props) => props.theme.sectionSpacer} 0;
  }

  background-color: ${({ theme }) => theme.footerBgColor || theme.grayColor};
  line-height: 1.5;
  font-style: normal;
  color: white;

  a {
    color: inherit;
    text-decoration: none;
    &:hover {
      color: ${(props) => props.theme.primaryColor};
    }
  }
`;

export default Footer;
